import React from "react";

import design from "../img/bg_element_3_wa.png";

import "../styles/components/promote.sass";

function Promote() {
  return (
    <section className="promo-container">
      <div className="promo-content">
        <h2>
          A W. Alberton está pronta para te ajudar a encontrar as soluções em
          tecnologia que sua empresa precisa.
        </h2>
        <img src={design} alt="" />
      </div>
    </section>
  );
}

export default Promote;
